import { cn } from "@roman/shared/utils";
import type React from "react";
import { useState } from "react";
import { InstructionIconButton } from "./infoIcon";

interface TableProps {
  name: string;
  className?: string;
  description?: {
    heading: string;
    content: string;
  };
}

export const Table: React.FC<TableProps> = ({ name, description, className }) => {
  const [isClicked, setIsClicked] = useState<boolean>(false);

  const handleInfoIcon = () => {
    setIsClicked((prev) => !prev);
  };

  const showDescriptionScreen = (): JSX.Element => {
    return (
      <>
        <div className="absolute bg-black z-10 bottom-full right-0 w-[235px] rounded-md">
          <div className="relative py-2.5 px-5">
            <div className="flex flex-col">
              <h5 className="text-[10px] font-bold text-white">{description?.heading}</h5>
              <p className="text-[10px] font-normal text-white">{description?.content}</p>
            </div>
          </div>
        </div>
        <div className="absolute -top-0.5 right-auto left-auto transform -translate-x-1/2 w-0 h-0 border-solid border-t-[#2D2D2D] border-t-[10px] border-r-transparent border-r-[7px] border-l-transparent border-l-[7px]" />
      </>
    );
  };

  return (
    <div className={cn("flex items-center justify-center relative z-10", className)}>
      {isClicked && showDescriptionScreen()}
      <p className="text-sm text-black font-medium shrink-0">{name}</p>
      {description && (
        <InstructionIconButton
          className="ml-1 w-[15px] h-[15px] text-white shrink-0"
          width="15"
          height="15"
          onClick={handleInfoIcon}
        />
      )}
    </div>
  );
};
